import axios from 'axios'
import Constants from '../constants'

export default {
  getPlaces: (lang, { location: location, genres: genres, token:token }) => {
    return new Promise((resolve) => {
      axios.get('place', { params: { id: Constants.API_ID, language: lang, geoPoint: location, tags: genres, token: token } })
        .then(payload => {
          let places = []
          if (payload.data.POI !== undefined) {
            payload.data.POI.forEach((poi) => {
              const g = Object.values(poi.tags)[0]
              const icon = g && g.img ? g.img : ''

              places.push({
                id: poi.poi_id,
                name: poi.shop_name,
                name_yomi: poi.shop_name_yomi,
                location: {
                  latitude: parseFloat(poi.latitude),
                  longitude: parseFloat(poi.longitude)
                },
                address: poi.address,
                genreIds: Object.keys(poi.tags),
                genreWords: Object.values(poi.tags),
                image: poi.img_main,
                detail: poi.shop_introduction,
                zipcode: poi.zipcode,
                accessDetails: poi.access_details,
                phoneNumber: poi.phone_number,
                businessHour: poi.business_hours,
                regularHoliday: poi.regular_holiday,
                url: poi.url,
                mapIcon: icon,
                benefits: poi.benefits,
                priority: poi.priority,
                distance: poi.distance
              });
            })
          }
          resolve(places)
        });
    })
  },
  getPlace: (id, lang) => {
    return new Promise((resolve) => {
      const params = {
        id: Constants.API_ID,
        poiId: id,
        language: lang
      }
      axios.get('place/detail', { params })
        .then(payload => {
          const place = payload.data
          resolve(Object.assign(place, { genreIds: Object.keys(place.tags) }))
        })
    })
  }
}
